// :: globals
// :: Define all global variables inside this folder
module.exports = {
  // :: Vuetify theme
  theme: {
    iconfont: "fa",
    colors: {
      primary: "#009D4F",
      accent: "#FFCD00",
      error: "#E21616",
      secondary: "#000",
      gray: "#EFEFEF",
      blueprosic: "#0071BC"
    }
  },
  // :: App
  app: {
    name: process.env.VUE_APP_NAME,
    id: process.env.VUE_APP_FIREBASE_PROJECT_ID
  }
};
